<template>
  <v-card
    class="flex-grow-1"
    rounded="lg"
    outlined
    :style="'border-color: ' + maincolor">
    <v-container>
      <v-row class="pa-3" v-if="!loading.refresh">
        <v-col cols="6" md="6" class="py-0">
          <v-img
            :lazy-src="require('../assets/default.jpg')"
            :src="jobact.urlpic ? jobact.urlpic : ''"
            max-height="70"
            max-width="70">
          </v-img>
        </v-col>
        <v-col cols="6" md="6" class="py-0 align-self-center">
          <div class="text-right">
            <v-icon color="warning" large v-if="jobact.app_status === 'apply'">
              mdi-clipboard-account
            </v-icon>
            <v-icon color="primary" large v-if="jobact.app_status === 'interview'">
              mdi-account-voice
            </v-icon>
            <v-icon color="error" large v-if="jobact.app_status === 'reject'">
              mdi-close-circle
            </v-icon>
            <v-icon color="success" large v-if="jobact.app_status === 'approve'">
              mdi-check-decagram
            </v-icon>
            <strong class="ml-1">{{ jobact.app_status }}</strong>
          </div>
        </v-col>
        <v-col cols="12" md="12" class="pt-0">
          <span class="caption font-weight-bold">{{ jobact.com_name }}</span>
          <h1 class="text-md-h5 font-weight-bold">
            <router-link :to="{ name: 'Jobdetail', query: { jobid: jobact.job_id } }">
              {{ jobact.job_name }}
            </router-link>
          </h1>
          <div class="my-3">
            <v-chip
              class="mr-1 mb-1"
              color="primary"
              outlined
              small
              dark>
              <v-icon left small>
                mdi-map-marker
              </v-icon>
              {{ jobact.job_location }}
            </v-chip>
            <v-chip
              class="mr-1 mb-1"
              color="orange"
              outlined
              small
              dark>
              <v-icon left small>
                mdi-av-timer
              </v-icon>
              {{ jobact.job_type }}
            </v-chip>
            <v-chip
              class="mr-1 mb-1"
              color="deep-orange"
              outlined
              small
              dark>
              <v-icon left small>
                mdi-cash-multiple
              </v-icon>
              {{ jobact.job_salary | rupiahformat }}
            </v-chip>
            <v-chip
              class="mr-1 mb-1"
              color="red darken-4"
              outlined
              small
              dark>
              <v-icon left small>
                mdi-calendar-range
              </v-icon>
              {{ jobact.job_valid }}
            </v-chip>
            <v-chip
              class="mr-1 mb-1"
              color="green"
              outlined
              small
              dark>
              <v-icon left small>
                mdi-account-hard-hat
              </v-icon>
              {{ jobact.job_special }}
            </v-chip>
          </div>
          <v-divider></v-divider>
          <div class="my-3">
            <v-row>
              <v-col cols="12" md="6">
                <span class="text-decoration-underline">Date</span>
                <h4 class="text-subtitle-1 font-weight-bold">
                  {{ jobact.app_inview_time ? jobact.app_inview_time : '-' }}
                </h4>
              </v-col>
              <v-col cols="12" md="6">
                <span class="text-decoration-underline">Place</span>
                <h4 class="text-subtitle-1 font-weight-bold">
                  {{ jobact.app_inview_location ? jobact.app_inview_location : '-' }}
                </h4>
              </v-col>
              <v-col cols="12" md="6">
                <span class="text-decoration-underline">Description</span>
                <div
                  class="content-editor"
                  v-html="jobact.app_inview_desc">
                </div>
              </v-col>
              <v-col cols="12" md="6">
                <span class="text-decoration-underline">Come to interview?</span>
                <h4 class="text-subtitle-1 font-weight-bold">
                  {{ jobact.app_inview_attend === '0' ? '-' : jobact.app_inview_attend }}
                </h4>
              </v-col>
            </v-row>
            <v-divider></v-divider>
            <v-row v-if="jobact.app_status === 'approve' || jobact.app_status === 'reject'">
              <v-col cols="12" md="6">
                <span class="text-decoration-underline">Decision</span>
                <div>
                  <strong>{{ jobact.app_status }}</strong>
                </div>
              </v-col>
              <v-col cols="12" md="6">
                <span class="text-decoration-underline">Feedback</span>
                <div
                  class="content-editor"
                  v-html="jobact.app_inview_feedback">
                </div>
              </v-col>
            </v-row>
          </div>
        </v-col>
        <v-col cols="12" md="12" class="py-0" v-if="alertdata.show">
          <alertsp :alertdata="alertdata"></alertsp>
        </v-col>
        <v-col cols="12" md="6" class="pt-0" v-if="jobact.app_status === 'interview' && jobact.app_inview_attend === '0'">
          <v-btn
            :loading="loading.interview"
            :disabled="jobact.app_status !== 'interview'"
            depressed
            large
            block
            outlined
            :color="maincolor"
            @click="updateStatus('no')">
            Not Come
          </v-btn>
        </v-col>
        <v-col cols="12" md="6" class="pt-0" v-if="jobact.app_status === 'interview' && jobact.app_inview_attend === '0'">
          <v-btn
            :loading="loading.interview"
            :disabled="jobact.app_status !== 'interview'"
            depressed
            large
            block
            :color="maincolor"
            @click="updateStatus('yes')"
            class="white--text">
            Come
          </v-btn>
        </v-col>
        <v-col cols="12" md="12" class="py-0 my-0">
          <span class="caption">
            <strong class="red--text">Note:</strong><br>
            Confirmation of arrival is only active if the company has set an interview schedule
          </span>
        </v-col>
      </v-row>
      <v-row class="pa-3" v-if="loading.refresh">
        <v-col cols="12" md="12">
          <v-progress-circular
            :width="3"
            color="red"
            indeterminate>
          </v-progress-circular>
        </v-col>
      </v-row>
    </v-container>
    <v-dialog
      v-model="appconfirm.modal"
      max-width="350">
      <v-card>
        <v-card-title class="headline">
          {{ appconfirm.title }}
        </v-card-title>
        <v-card-text>
          {{ appconfirm.text }}
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="green darken-1"
            text
            :to="{ name: 'Register' }">
            Sign Up
          </v-btn>
          <v-btn
            color="green darken-1"
            text
            :to="{ name: 'Login' }">
            Log In
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>
<script>
import qs from 'qs';
import { mapState } from 'vuex';
import { priceFromat } from '@/plugins/utils';
import Alertsp from './Alert.vue';

export default {
  props: ['job'],
  data: () => ({
    jobact: null,
    alertdata: {
      show: false,
      type: 'warning',
      text: '',
    },
    loading: {
      interview: false,
      refresh: false,
      apply: false,
      save: false,
    },
    appconfirm: {
      modal: false,
      title: 'Apply for job',
      text: 'Only registered job seekers can apply the job, please Sign Up and Sign In as a jobseeker first. Thank you',
    },
    api: process.env.VUE_APP_API,
    maincolor: process.env.VUE_APP_MAINCOLOR,
    isapply: false,
    issave: false,
  }),
  created() {
    this.jobact = this.job;
  },
  computed: {
    ...mapState([
      'isAuth',
      'tokenpub',
      'tokenscr',
      'userrole',
      'userjob',
      'usersjob',
    ]),
  },
  mounted() {
    this.jobact = this.job;
  },
  filters: {
    // For filter render
    rupiahformat(value) {
      if (!value) {
        return '';
      } else {
        return priceFromat(value, 'Rp');
      }
    },
  },
  methods: {
    updateStatus(status) {
      this.alertdata.show = false;
      if (this.tokenscr) {
        this.loading.interview = true;
        this.jobact.app_inview_attend_new = status;
        this.axios
          .post(
            this.api + '/api/jobs/update-interview-js',
            qs.stringify(this.jobact),
            {
              headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': 'bearer ' + this.tokenscr,
              },
            },
          )
          .then((res) => {
            if (res.status === 200) {
              const resdata = res.data;
              // console.log(resdata);
              if (resdata.error === false) {
                this.refreshData();
                this.alertdata.show = true;
                this.alertdata.type = 'success';
                this.alertdata.text = 'Confirmation of arrival of interview sent successfully';
              } else {
                this.alertdata.show = true;
                this.alertdata.type = 'error';
                this.alertdata.text = resdata.message;
              }
            } else {
              this.alertdata.show = true;
              this.alertdata.type = 'error';
              this.alertdata.text = 'Internal services error!';
            }
            this.loading.interview = false;
          })
          .catch((error) => {
            console.log(error);
            this.alertdata.show = true;
            this.alertdata.type = 'error';
            this.alertdata.text = 'Internal services error!';
            this.loading.interview = false;
          });
      } else {
        this.alertdata.show = true;
        this.alertdata.type = 'error';
        this.alertdata.text = 'Invalid token!';
      }
    },
    refreshData() {
      if (this.tokenscr && this.jobact.app_id !== '') {
        this.loading.refresh = true;
        this.axios
          .get(
            this.api + '/api/jobs/apply-js/' + this.jobact.app_id,
            {
              params: {},
              headers: {
                Authorization: 'bearer ' + this.tokenscr,
              },
            },
          )
          .then((res) => {
            if (res.status === 200) {
              const resdata = res.data;
              if (resdata.error === false) {
                const newdata = [];
                resdata.data.forEach((element) => {
                  element.urlpic = this.api + '/upload/avatar/' + element.js_picture;
                  newdata.push(element);
                });
                this.jobact = newdata[0];
              }
            }
            this.loading.refresh = false;
          })
          .catch((error) => {
            console.log(error);
            this.loading.refresh = false;
          });
      }
    },
  },
  components: {
    Alertsp,
  },
};
</script>